import { useEffect, useRef, useState } from 'react';
import Button from '@ingka/button';
import Menu from '@ingka/ssr-icon/paths/menu';
import { DashboardLink } from '../links/DashboardLink/DashboardLink';
import { RequestLink } from '../links/RequestLink/RequestLink';
import { FilterLink } from '../links/FilterLink/FilterLink';
import { ReportsLink } from '../links/ReportsLink/ReportsLink';
import KunskapLink from '../links/KunskapLink/KunskapsLink';
import ExportButton from '../buttons/ExportButton';
import styles from './HeaderAppsButton.module.scss';

const HeaderAppsButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const launcherRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const closeMenuOnClick = (event: MouseEvent) => {
      const control =
        event.target instanceof Element
          ? event.target.closest('button, a[href]')
          : null;
      if (
        event.target instanceof Node &&
        (!launcherRef.current?.contains(event.target) ||
          (control?.closest('#header-apps-menu') &&
            !control.matches(':disabled, [aria-disabled="true"]')))
      ) {
        if (menuRef.current?.contains(document.activeElement)) {
          buttonRef.current?.focus();
        }
        setIsOpen(false);
      }
    };
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
        buttonRef.current?.focus();
      }
    };

    document.addEventListener('click', closeMenuOnClick);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('click', closeMenuOnClick);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [isOpen]);

  return (
    <div ref={launcherRef}>
      <Button
        ref={buttonRef}
        type="tertiary"
        size="small"
        iconOnly
        aria-label="Toggle application menu"
        aria-expanded={isOpen}
        aria-controls={isOpen ? 'header-apps-menu' : undefined}
        onClick={() => setIsOpen((open) => !open)}
        ssrIcon={Menu}
      />
      {isOpen && (
        <nav
          ref={menuRef}
          className={styles.menu}
          id="header-apps-menu"
          aria-label="Application links"
        >
          <ul className={styles.apps}>
            <li>
              <DashboardLink />
              <span>Shop dashboard</span>
            </li>
            <li>
              <RequestLink />
              <span>Market request</span>
            </li>
            <li>
              <FilterLink />
              <span>Indexable filters</span>
            </li>
            <li>
              <ReportsLink />
              <span>Reports</span>
            </li>
            <li>
              <ExportButton />
              <span>Export</span>
            </li>
            <li>
              <KunskapLink />
              <span>Help</span>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default HeaderAppsButton;
